import React, { useState, useEffect } from "react";
import Board from "react-trello";
import moment from "moment";
import { Link } from "react-router-dom";

import { Divider, Icon, Popover } from "antd";
import { UserIcon } from "components";
import { history } from "utils";
import { analyzeService, submissionService, selectService } from "services";
import {
  ANALYSIS_TYPE_FINANCE,
  ANALYSIS_TYPE_TECHNICAL,
  ANALYSIS_TYPE_CHANCE,
  ANALYSIS_SCALE_HIGH,
  ANALYSIS_SCALE_MODERATE,
  SUBMISSION_STATE_CANCELLED,
  SUBMISSION_STATE_NOTWON,
  SUBMISSION_STATE_WON,
} from "constants/dbValues";
import { icons } from "constants/icons";
import { dateFormat } from "utils";

function getStatus(score, isChance = false) {
  try {
    if (score > ANALYSIS_SCALE_HIGH) return !isChance ? "danger" : "success";
    if (score > ANALYSIS_SCALE_MODERATE) return "primary";
    if (score > 0) return !isChance ? "success" : "danger";
  } catch {}
  return "default";
}

const CustomCard = ({ submission, scores }) => {
  const chanceScore = scores.chance != null ? parseInt(scores.chance) : null;
  const riskScore = scores.risk != null ? parseInt(scores.risk) : null;
  const action = () => history.push(`/submissions/${submission.id}`);

  const PopoverCard = () => (
    <div className="card-kanban" style={{ boxShadow: "initial" }}>
      <div className="body" onClick={action}>
        <ul className="tags">
          <li>
            <Icon type={icons.client} />
            {submission.client?.name}
          </li>
          <li className="alt">
            <Icon type="fork" />
            {submission.submission_state?.label}
          </li>
          <li className="alt">
            <Icon type="tag" />
            {submission.project_type?.label}
          </li>
          <li className="alt">
            <Icon type="pushpin" />
            {submission.region?.label}
          </li>
        </ul>

        <div className="infos">
          <p className="ctn notes">
            <label>Notes : </label>
            <b className="data-empty">{submission.note}</b>
          </p>
        </div>

        <div className="scores">
          <div className={getStatus(riskScore)}>
            <h4>Risques</h4>
            <b className="data-empty percentage">{riskScore}</b>
          </div>
          <div className={getStatus(chanceScore, true)}>
            <h4>Chance</h4>
            <b className="data-empty percentage">{chanceScore}</b>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Popover
      trigger={["hover", "click"]}
      placement="bottom"
      content={<PopoverCard />}
      color="white"
    >
      <div className="card-kanban">
        <div className="header">
          <div className="click-wrap" onClick={action}>
            <h3>{submission.title}</h3>
            <small className="data-empty">#{submission.num}</small>
            <ul className="tags">
              <li>
                <Icon type={icons.client} />
                {submission.client?.name}
              </li>
              {submission.date_depot ? (
                <li className="alt">
                  <Icon type="calendar" style={{ marginRight: 6 }} />
                  {moment(submission.date_depot).format(dateFormat)}
                </li>
              ) : (
                <></>
              )}
            </ul>
          </div>
          <UserIcon link user={submission.user} />
        </div>
      </div>
    </Popover>
  );
};

const SubmissionsKanban = (props) => {
  const [data, setData] = useState({ lanes: [] });

  useEffect(() => {
    const fetchAnalysis = (submissions) => {
      let submission_id = submissions;
      if (!Array.isArray(submissions)) submission_id = [submissions];
      return analyzeService.list({ submission_id }).then((results) => {
        const scores = {};
        for (let i = 0; i < submission_id.length; ++i) {
          const result = results.filter((r) => r.submission_id == submission_id[i]);
          const financeScore = result.find(
            (ana) => ana.analyze_type_id === ANALYSIS_TYPE_FINANCE,
          )?.value;
          const technicalScore = result.find(
            (ana) => ana.analyze_type_id === ANALYSIS_TYPE_TECHNICAL,
          )?.value;
          const chanceScore = result.find(
            (ana) => ana.analyze_type_id === ANALYSIS_TYPE_CHANCE,
          )?.value;
          scores[submission_id[i]] = {
            risk:
              financeScore != null && technicalScore != null
                ? (Number(financeScore) + Number(technicalScore)) * 0.005
                : null,
            chance: chanceScore != null ? Number(chanceScore) * 0.01 : null,
          };
        }
        return scores;
      });
    };

    const fetchSubmissions = async () => {
      // Toutes les undecided et seulement les "won" dans les 30 derniers jours
      const { submissions, states } = await submissionService.listSubmissions(
        {},
        { date_depot: [moment().subtract(30, "days").toISOString(), moment().toISOString()] },
        [SUBMISSION_STATE_CANCELLED, SUBMISSION_STATE_NOTWON],
      );

      const scores = await fetchAnalysis(submissions.map((s) => s.id));

      const cards = submissions.map((submission) => ({
        id: submission.id,
        title: submission.title,
        label: submission.id,
        state_id: submission.submission_state_id,
        draggable: false,
        submission,
        scores: scores[submission.id] || {},
      }));

      const lanes = states.map((state) => ({
        id: state.id + "",
        title: state.label,
        cards: cards.filter((card) => card.state_id === state.id),
      }));

      setData({ lanes });
    };

    fetchSubmissions();
  }, []);

  return (
    <Board
      components={{ Card: CustomCard }}
      data={data}
      editable={false}
      draggable={false}
      laneDraggable={false}
      cardDraggable={false}
      hideCardDeleteIcon={true}
      onCardClick={(id) => history.push(`/submissions/${id}`)}
    />
  );
};

export default SubmissionsKanban;
